import { useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { getBadgeSlotSx, StyledBadge, type BadgePlacement } from './NewFeatureBadge.style';

const NEW_FEATURE_DURATION_DAYS = 31;

export type NewFeatureBadgeProps = {
  releaseDate?: string | Date;
  top?: string;
  right?: string;
  placement?: BadgePlacement;
  children: ReactNode;
};

export function NewFeatureBadge({ releaseDate, top, right, placement = 'overlay', children }: NewFeatureBadgeProps) {
  const [now] = useState(() => new Date());
  const { t } = useTranslation();

  if (!releaseDate) {
    return <>{children}</>;
  }

  const start = new Date(releaseDate);
  const expires = new Date(start);
  expires.setDate(start.getDate() + NEW_FEATURE_DURATION_DAYS);
  const isVisible = !Number.isNaN(start.getTime()) && start <= now && now <= expires;

  if (!isVisible) {
    return <>{children}</>;
  }

  return (
    <StyledBadge
      placement={placement}
      data-badge-placement={placement}
      badgeContent={t('general.new')}
      overlap="circular"
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
      slotProps={{ badge: { sx: getBadgeSlotSx({ placement, top, right }) } }}
    >
      {children}
    </StyledBadge>
  );
}
